import React from "react";
import { Create } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { DriverForm } from "./DriverForm";
import { useNotification } from "../../../common/hooks/useNotification";
import { useFieldPermissions } from "../../../common/hooks/useFieldPermissions";
import { protectedEntities } from "../../../common/auth/permissions";
import { FieldPermissionsContext } from "../../common/field-permissions/FieldPermissionsContext";

interface IDriverCreateProps {
  basePath?: string;
  resource?: string;
}

export const DriverCreate = (props: IDriverCreateProps) => {
  const notify = useNotification(props, "createSuccess");
  const fieldPermissions = useFieldPermissions(
    protectedEntities.Driver,
    (x) => x.create
  );
  return (
    <FieldPermissionsContext.Provider value={fieldPermissions}>
      <Create
        {...props}
        actions={<EditActions />}
        title="resources.admin-drivers.title.create"
        onSuccess={notify}>
        <DriverForm />
      </Create>
    </FieldPermissionsContext.Provider>
  );
};
